import { render, staticRenderFns } from "./Nutraceuticals.vue?vue&type=template&id=23581184"
import script from "./Nutraceuticals.vue?vue&type=script&lang=js"
export * from "./Nutraceuticals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23581184')) {
      api.createRecord('23581184', component.options)
    } else {
      api.reload('23581184', component.options)
    }
    module.hot.accept("./Nutraceuticals.vue?vue&type=template&id=23581184", function () {
      api.rerender('23581184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/pharmacy/Nutraceuticals.vue"
export default component.exports